// extracted by mini-css-extract-plugin
export default {"sampleQuery":"SampleQueries_sampleQuery__b3Ftg"};